import React from 'react'
import { WidgetCard } from '../style'
import { AbrechnungRow } from '../widgets/InvoicesWidget/style'
import { SkeletonLine } from './skeleton.style'

const InvoicesWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    <SkeletonLine width='120px' height='18px' style={{ marginBottom: '20px' }} />
    {[...Array(5)].map((_, i) => (
      <AbrechnungRow key={i}>
        <SkeletonLine width='140px' height='14px' style={{ marginBottom: 0 }} />
        <SkeletonLine width='80px' height='14px' style={{ marginBottom: 0 }} />
      </AbrechnungRow>
    ))}
  </WidgetCard>
)

export default InvoicesWidgetSkeleton
